import { isNextControlFlowDigest } from "@shared/telemetry/next-control-flow";

function controlFlowDigestOf(error: unknown): string | null {
  if (!(error instanceof Error)) return null;
  const digest: unknown = Reflect.get(error, "digest");
  return typeof digest === "string" && isNextControlFlowDigest(digest) ? digest : null;
}

// WHY: a redirect() or notFound() inside a streamed Suspense boundary reaches the browser as React #419 carrying the signal's digest, and vinext's onRecoverableError hands it to reportError while its onCaughtError skips the same signal. PostHog takes the exception type from error.name and drops the digest, so naming the error after its digest before PostHog's window.onerror wrapper runs lets the existing control-flow filter recognise that exact error and no other.
export function installNavigationSignalRecoverableErrorTracking(target: Window): void {
  target.addEventListener(
    "error",
    (event) => {
      const digest = controlFlowDigestOf(event.error);
      if (digest !== null && event.error instanceof Error) event.error.name = digest;
    },
    { capture: true },
  );
}
